export default "__VITE_ASSET__BdfAxmMV__"